import {agentIpFeeLogList} from 'api/agentIpFeeLog';
import Cookies from 'js-cookie';

const agentIpFeeLog = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        agentIpFeeLogList({commit},params) {
            return new Promise((resolve, reject) => {
                var startTime = params.startTime;
                var endTime = params.endTime;
                var agent = params.agent;
                var pageSize = params.pageSize;
                var currentPage = params.currentPage;
                agentIpFeeLogList(startTime,endTime,agent,pageSize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default agentIpFeeLog;



// WEBPACK FOOTER //
// ./src/store/modules/agentIpFeeLog.js